import { render, staticRenderFns } from "./SquadraCrediti.vue?vue&type=template&id=b1fae86a&scoped=true&"
import script from "./SquadraCrediti.vue?vue&type=script&lang=js&"
export * from "./SquadraCrediti.vue?vue&type=script&lang=js&"
import style0 from "./SquadraCrediti.vue?vue&type=style&index=0&id=b1fae86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1fae86a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1fae86a')) {
      api.createRecord('b1fae86a', component.options)
    } else {
      api.reload('b1fae86a', component.options)
    }
    module.hot.accept("./SquadraCrediti.vue?vue&type=template&id=b1fae86a&scoped=true&", function () {
      api.rerender('b1fae86a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SquadraCrediti.vue"
export default component.exports